<template>
  <div class="play-container">
    <top-bar :user="this.user" />
    <Menu :user="this.user" :menuSelected="{ manageUsers: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ manageUsers: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
      }">
        <div>
          <h1>
            <p>{{ $t("cmsLang.managementTitle") }}</p>
            <a @click="addModifyUser(null)" class="button-all button-yellow">
              <img src="@/assets/images/cms-mkt/plus.svg" />
              {{ $t('cmsLang.addUserLabel') }}
            </a>

          </h1>
        </div>

        <div v-if="users !== null && users.length > 0">
          <div v-for="(userList, index) in users" :key="index" class="d-inline-block position-relative">
            <div class="offer-wrapper" >
              <img class="personimg" :src="getImagePath() + 'users/' + userList.id + '.png'"
                @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" />
              <div width="30%">
                <p class="description">
                  {{ userList.first_name ? userList.first_name + " " + userList.last_name : userList.username }}
                </p>
              </div>
              <div v-if="userList.config">
                <p class="small">
                  {{ $t('cmsLang.userRole_' + userList.config.roles[0]) }}
                </p>
                <br />
                <!-- v-if="user.companies[0].user_config.roles[0] === 'ADMIN' && userList.config.roles[0] !== 'ADMIN'"> -->
                <a @click="addModifyUser(userList)" class="edit"
                v-if="user.config.roles[0] === 'ADMIN' && userList.config.roles[0] !== 'ADMIN'">
                <img src="@/assets/images/cms-mkt/edit.svg" />
              </a>
              <!-- v-if="user.companies[0].user_config.roles[0] === 'ADMIN' && userList.config.roles[0] !== 'ADMIN'"> -->
              <a @click="showDeleteUserPopup(userList)" class="delete"
                  v-if="user.config.roles[0] === 'ADMIN' && userList.config.roles[0] !== 'ADMIN'">
                  <img src="@/assets/images/cms-mkt/delete.svg" />
                </a>
                 <br v-else />
              </div>
            </div>
          </div>

        </div>
        <div v-else class="loading">
          <img src="@/assets/images/cms-mkt/loading.gif" />
        </div>
      </div>
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <p>{{ $t("cmsLang.confirmDeleteUserMessage") }}</p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteUser()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="noChangeRole()">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>

    <div id="modal_popup_add_user" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_add_user', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div class="offer-details-wrapper">
          <form @submit.prevent="addModifyUserForm()">
            <table width="95%" align="center" cellpadding="10" cellspacing="0">
              <tr style="border-bottom: 1px solid #DEDEDE">
                <td align="left" colspan="2">
                  <h2>{{ this.selectedUserForAction ? $t("cmsLang.modifyUserLabel") : $t("cmsLang.addUserLabel") }}</h2>
                </td>
              </tr>
              <tr v-if="!this.selectedUserForAction">
                <td align="left">
                  <small>{{ $t("cmsLang.lastNameLabel") }}</small>
                  <br />
                  <input type="text" required v-model="formData.last_name" class="formedituser" />
                </td>
                <td align="left">
                  <small>{{ $t("cmsLang.firstNameLabel") }}</small>
                  <br />
                  <input type="text" v-model="formData.first_name" required class="formedituser" />
                </td>
              </tr>
              <tr v-if="!this.selectedUserForAction">
                <td align="left" colspan="2">
                  <small>{{ $t("cmsLang.emailLabel") }}</small>
                  <br />
                  <input type="text" v-model="formData.username" required class="formedituser" />
                </td>
              </tr>
              <tr>
                <td align="left" colspan="2">
                  <small>{{ $t("cmsLang.roleCompanyLabel") }}</small>
                  <br />

                  <div class="form-check mr-2 align-baseline d radioButtonCustom">
                    <label v-for="(role, index) in roles" :key="index">
                      <input name="roleradio" class="radioButtonCustom" type="radio" :value="role"
                        v-model="formData.role">
                      {{ $t('cmsLang.userRole_' + role) }}</label>
                  </div>

                </td>
              </tr>
              <tr>
                <td align="left">
                  <input type="submit" :value="[[$t('cmsLang.confirmButtonLabel')]]" variant="primary" class="submitCompanies" />
                </td>
                <td align="left">
                  <a @click="showModalPopup('modal_popup_add_user', false)" class="pointer">
                    {{ $t("cmsLang.cancelChangesLabel") }}
                  </a>
                </td>
              </tr>
            </table>
          </form>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <div v-if="this.userManageError">
          <p v-html="$t('cmsLang.errorMessage_' + this.userManageError.code)"></p>
        </div>
        <div v-else-if="addNewUserSuccess">
          <p>{{ $t("cmsLang.addUserSuccessMessage") }}</p>
        </div>
        <div v-else-if="modifyUserSuccess">
          <p>{{ $t("cmsLang.modifyUserSuccessMessage") }}</p>
        </div>
        <div v-else-if="deleteUserSuccess">
          <p>{{ $t("cmsLang.deleteUserSuccessMessage") }}</p>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
  </div>
</template>

<script>
import httpServiceUser from "@/http/http-user-mkt.js";
import Menu from "@/components/cms-mkt/Menu.vue";
import TopBar from "@/components/cms-mkt/TopBar.vue";
import Cookies from "js-cookie";
import validator from "@/plugins/fieldValidation";
import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";

export default {
  name: "ManageUsers",

  components: {
    TopBar,
    Menu,
    ResetPassword
  },
  data() {
    return {
      user: null,
      companyDataError: null,
      editMode: false,
      formData: {},
      users: null,
      roles: ["ADMIN", "EDITOR"],
      detailsMobile: false,
      userSelectedMobile: null,
      selectedUserForAction: null,
      userManageError: null,
      addNewUserSuccess: false,
      modifyUserSuccess: false,
      deleteUserSuccess: false,
      switchModifyOrDelete: "MODIFY", // false = Modify | true = Delete
    };
  },
  methods: {
    selectUserMobile(index) {
      this.userSelectedMobile = this.users[index];
      this.detailsMobile = !this.detailsMobile;
    },
    noChangeRole() {
      // this.getUsers();
      this.showModalPopup("modal_popup_confirm", false);
    },
    addModifyUserForm() {
      if (this.formData.id && this.formData.id > 0) {
        this.modifyUser();
      } else {
        this.addNewUser();
      }
    },
    addNewUser() {
      let error = false;
      if (!validator.validateEmail(this.formData.username)) {
        this.userManageError = {
          code: "UA2",
        };
        error = true
      }
      if (!validator.validateOnlyAlphanumeric(this.formData.first_name.trim())) {
        this.userManageError = {
          code: "UA0",
        };
        error = true
      }
      if (!validator.validateOnlyAlphanumeric(this.formData.last_name.trim())) {
        this.userManageError = {
          code: "UA0",
        };
        error = true
      }

      if (error) {
        this.showModalPopup("modal_popup_info", true);
        return;
      }
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      // this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceUser.userService
        .addUser(
          {
            username: this.formData.username,
            first_name: this.formData.first_name,
            last_name: this.formData.last_name,
            config: { roles: [this.formData.role] },
          },
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200) {
            this.addNewUserSuccess = true;
            this.formData = {
              username: "",
              first_name: "",
              last_name: "",
              role: "",
            },
              this.getUsers();
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
            this.showModalPopup("modal_popup_add_user", false);

          } else {
            this.userManageError = { code: response.data[0] };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { code: error.response.data[0] };
          } else {
            this.userManageError = { code: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    getUsers() {
      this.userManageError = null;
      this.users = null;

      httpServiceUser.userService
        .searchUsers(
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200) {
            this.users = response.data;
          } else {
            this.userManageError = { code: response.data[0] };
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { code: error.response.data[0] };
          } else {
            this.userManageError = { code: "undefined" };
          }
          this.showModalPopup("modal_popup_info", true);
        });
    },
    modifyUser() {
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      this.showModalPopup("modal_popup_confirm", false);
      this.showModalPopup("modal_popup_loading_cms", true);

      this.selectedUserForAction.config.roles = [this.formData.role];

      httpServiceUser.userService
        .promoteUser(
          this.selectedUserForAction.id,
          this.selectedUserForAction,
          Cookies.get("token")
        ).catch((error) => {
          return error.response;
        })
        .then((response) => {
          if (response.status == 200 || response.status == 204 || response.status == 304) {
            this.modifyUserSuccess = true;
            this.getUsers();
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
            this.showModalPopup("modal_popup_add_user", false);

          } else {
            this.userManageError = { code: response.data[0] };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          }
          this.showModalPopup("modal_popup_loading_cms", false);

        })
        ;
    },
    deleteUser() {
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      this.showModalPopup("modal_popup_confirm", false);
      // this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceUser.userService
        .deleteUser(
          this.selectedUserForAction.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.deleteUserSuccess = true;
            this.getUsers();
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
            this.showModalPopup("modal_popup_add_user", false);

          } else {
            this.userManageError = { code: response.data[0] };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { code: error.response.data[0] };
          } else {
            this.userManageError = { code: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    showDeleteUserPopup(user) {
      this.selectedUserForAction = user;
      this.showModalPopup("modal_popup_confirm", true);
    },
    addModifyUser(user) {
      if (user === null) {
        this.formData = {};
        this.selectedUserForAction = null;
      } else {
        this.selectedUserForAction = user;
        this.formData = {
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          role: user.config.roles[0]
        }
      }
      this.addNewUserSuccess = false;
      this.showModalPopup("modal_popup_add_user", true);
    },
  },
  mounted() {
    this.getUsers();
  },
  computed: {},
  created() {
    this.user = this.getUser();

  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.formedituser.email {
  min-width: 200px;
}
</style>
